export default async function reserveSeatsInBulk({
  availableSeats,
  seats,
  wagonNumber,
  reserveSeat,
  unReserveSeat,
}) {
  try {
    const reservationPromises = availableSeats.map(
      (seat) => reserveSeat(seats?.[seat], wagonNumber),
    );
    await Promise.all(reservationPromises);
  } catch {
    const cancelReservationPromises = availableSeats.map(
      (seat) => unReserveSeat(seats?.[seat], wagonNumber),
    );
    await Promise.all(cancelReservationPromises);
  }
}
